import { render, staticRenderFns } from "./cursos-detalles-participantes.vue?vue&type=template&id=ed1a86f4&scoped=true&"
import script from "./cursos-detalles-participantes.vue?vue&type=script&lang=ts&"
export * from "./cursos-detalles-participantes.vue?vue&type=script&lang=ts&"
import style0 from "./cursos-detalles-participantes.vue?vue&type=style&index=0&id=ed1a86f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1a86f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VList,VListItem,VListItemGroup,VRow,VSpacer})
